var _excluded = ["inNewTab"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import React, { memo, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Box, Font, disableScroll, CloseActionIcon, SettingsActionIcon, CircleUserIcon, QuestionSignIcon, PinBubbleDefaultMapIcon, VkLogoIcon, OkLogoIcon, TelegramLogoIcon, AlisaLogoIcon, ChevronLeftNavigationIcon, ChevronRightNavigationIcon, ExitNavigationIcon, BoxDefaultPostalIcon, useSsr } from "@pochta/ui";
import debounce from "../../../../../../helpers/debounce";
import BannerPlace from "../../../../../promotion/BannerPlace";
import isActiveUrl from "../../../../../../helpers/isActiveUrl";
import HeaderLink from "../HeaderLink";
import isExternalHost from "../../helpers/isExternalHost";
var MobileMenuWrapper = styled(Box).withConfig({
  displayName: "MobileMenu__MobileMenuWrapper",
  componentId: "sc-1skdlw6-0"
})(["display:none;", "{display:flex;}position:fixed;top:0;left:0;bottom:0;width:", "px;z-index:", ";transition:all 0.3s;overflow:scroll;transform:translate( ", "px,0 );"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.notDesktop;
}, function (_ref2) {
  var screenWidth = _ref2.screenWidth;
  return screenWidth * 3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.zIndex.higher * 100;
}, function (_ref4) {
  var screenWidth = _ref4.screenWidth,
      phase = _ref4.phase;
  return [phase === "3" && -screenWidth * 2, phase === "2" && -screenWidth, phase === "1" && "0", screenWidth].find(Boolean);
});
var MobileMenuItemInner = styled(HeaderLink).withConfig({
  displayName: "MobileMenu__MobileMenuItemInner",
  componentId: "sc-1skdlw6-1"
})(["display:flex;align-items:center;padding:13px 20px 13px 36px;border-bottom-color:transparent;position:relative;color:", ";&:visited{color:", ";}&:before{content:\"\";width:8px;height:8px;background:", ";border-radius:5px;position:absolute;top:50%;margin-top:-4px;left:15px;}"], function (_ref5) {
  var color = _ref5.theme.color,
      isActive = _ref5.isActive;
  return !isActive ? color.text.black.base : color.importance.primary.base;
}, function (_ref6) {
  var color = _ref6.theme.color,
      isActive = _ref6.isActive;
  return !isActive ? color.text.black.base : color.importance.primary.base;
}, function (_ref7) {
  var theme = _ref7.theme,
      isActive = _ref7.isActive;
  return isActive ? theme.color.importance.primary.base : "transparent";
});
export var MobileMenuItem = function MobileMenuItem(_ref8) {
  var _ref8$inNewTab = _ref8.inNewTab,
      inNewTab = _ref8$inNewTab === void 0 ? false : _ref8$inNewTab,
      props = _objectWithoutProperties(_ref8, _excluded);

  var inNewTabProps = {};

  if (inNewTab) {
    inNewTabProps = {
      target: "_blank",
      rel: "noreferrer"
    };
  }

  return /*#__PURE__*/React.createElement(MobileMenuItemInner, _extends({}, props, inNewTabProps));
};

var MobileMenu = function MobileMenu(_ref9) {
  var isOpen = _ref9.isOpen,
      _ref9$menu = _ref9.menu,
      menu = _ref9$menu === void 0 ? [] : _ref9$menu,
      authorized = _ref9.authorized,
      userName = _ref9.userName,
      postIdLoginUrl = _ref9.postIdLoginUrl,
      postIdUserAccountUrl = _ref9.postIdUserAccountUrl,
      postIdLogoutUrl = _ref9.postIdLogoutUrl,
      officesUrl = _ref9.officesUrl,
      supportUrl = _ref9.supportUrl,
      trackingUrl = _ref9.trackingUrl,
      aboutUrl = _ref9.aboutUrl,
      newsUrl = _ref9.newsUrl,
      vacancyUrl = _ref9.vacancyUrl,
      onClickPostIdLogin = _ref9.onClickPostIdLogin,
      onClickSettings = _ref9.onClickSettings,
      onClickLogout = _ref9.onClickLogout,
      onClose = _ref9.onClose;

  var _useSsr = useSsr(),
      isSsr = _useSsr.isSsr;

  var _useState = useState(isSsr ? 1000 : window.innerWidth),
      _useState2 = _slicedToArray(_useState, 2),
      screenWidth = _useState2[0],
      setScreenWidth = _useState2[1];

  useEffect(function () {
    setScreenWidth(window.innerWidth);
  }, []);

  var _useState3 = useState([[], []]),
      _useState4 = _slicedToArray(_useState3, 2),
      currentSubmenu = _useState4[0],
      setSubmenu = _useState4[1];

  var _useState5 = useState("0"),
      _useState6 = _slicedToArray(_useState5, 2),
      phase = _useState6[0],
      setPhase = _useState6[1];

  var _useState7 = useState(["", ""]),
      _useState8 = _slicedToArray(_useState7, 2),
      backCategoryName = _useState8[0],
      setBackCategoryName = _useState8[1];

  var previousIsOpen = useRef(false);
  var wrapperRef = useRef(null);
  useEffect(function () {
    if (previousIsOpen.current !== isOpen && isOpen) {
      setPhase("1");
    }

    if (!isOpen) {
      setPhase("0");
    }

    previousIsOpen.current = isOpen;
    disableScroll(isOpen);
  }, [isOpen]);

  var menuEnterHandler = function menuEnterHandler(submenuIndex) {
    return function (event) {
      var _wrapperRef$current;

      if (menu.length === 0) return;
      var _menu$submenuIndex = menu[submenuIndex],
          _menu$submenuIndex$it = _menu$submenuIndex.items,
          submenu = _menu$submenuIndex$it === void 0 ? [] : _menu$submenuIndex$it,
          title = _menu$submenuIndex.title;
      event.preventDefault();
      (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.scrollTo(0, 0);
      setSubmenu([submenu, []]);
      setPhase("2");
      setBackCategoryName([title, ""]);
    };
  };

  var submenuHandler = function submenuHandler(submenu, submenuBackCategoryName) {
    return function (event) {
      var _wrapperRef$current2;

      event.preventDefault();
      (_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : _wrapperRef$current2.scrollTo(0, 0);
      setSubmenu([currentSubmenu[0], submenu]);
      setBackCategoryName([backCategoryName[0], submenuBackCategoryName]);
      setPhase("3");
    };
  };

  var backHandler = function backHandler(phaseIndex) {
    return function () {
      return setPhase(phaseIndex);
    };
  };

  useEffect(function () {
    var resizeHandler = debounce(function () {
      var newWidth = window.innerWidth;
      setScreenWidth(newWidth);
    }, 100);
    window.addEventListener("resize", resizeHandler);
    return function () {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);
  return /*#__PURE__*/React.createElement(MobileMenuWrapper, {
    flexbox: true,
    flex: "1 0",
    bg: "neutralsWhite.hex5",
    screenWidth: screenWidth,
    phase: phase,
    "data-testid": "mobile-menu",
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    flexDirection: "column",
    flex: "1 0",
    width: screenWidth
  }, /*#__PURE__*/React.createElement(Box, {
    pb: 7,
    borderBottom: "1px solid neutralsBlack.hex10"
  }, !authorized && /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    height: 46,
    alignItems: "center",
    p: "0 18px 0 14px"
  }, /*#__PURE__*/React.createElement(CircleUserIcon, {
    size: "s",
    mr: 6
  }), /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    size: "m",
    href: postIdLoginUrl,
    onClick: onClickPostIdLogin
  }, "\u0412\u043E\u0439\u0442\u0438"), /*#__PURE__*/React.createElement(CloseActionIcon, {
    fontSize: "20px",
    ml: "auto",
    onClick: onClose
  })), authorized && /*#__PURE__*/React.createElement(Box, {
    pb: 7,
    borderBottom: "1px solid neutralsBlack.hex10"
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    height: 46,
    alignItems: "center",
    p: "0 18px 0 14px"
  }, /*#__PURE__*/React.createElement(CircleUserIcon, {
    size: "s",
    mr: 6
  }), /*#__PURE__*/React.createElement(Box, {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Font, {
    size: "m"
  }, userName)), /*#__PURE__*/React.createElement(Box, {
    ml: "auto"
  }, /*#__PURE__*/React.createElement(CloseActionIcon, {
    fontSize: "20px",
    onClick: onClose
  }))), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    height: 46,
    alignItems: "center",
    p: "0 18px 0 14px"
  }, /*#__PURE__*/React.createElement(BoxDefaultPostalIcon, {
    size: "s",
    mr: 6
  }), /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    size: "m",
    href: trackingUrl
  }, "\u041C\u043E\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F")), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    height: 46,
    alignItems: "center",
    p: "0 18px 0 14px"
  }, /*#__PURE__*/React.createElement(SettingsActionIcon, {
    size: "s",
    mr: 6
  }), /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    size: "m",
    href: postIdUserAccountUrl,
    onClick: onClickSettings
  }, "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438")), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    height: 46,
    alignItems: "center",
    p: "0 18px 0 14px"
  }, /*#__PURE__*/React.createElement(ExitNavigationIcon, {
    size: "s",
    mr: 6
  }), /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    size: "m",
    href: postIdLogoutUrl,
    onClick: onClickLogout,
    "data-testid": "\u043C\u043E\u0431\u0438\u043B\u043A\u0430"
  }, "\u0412\u044B\u0439\u0442\u0438"))), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    height: 46,
    alignItems: "center",
    p: "0 18px 0 14px"
  }, /*#__PURE__*/React.createElement(QuestionSignIcon, {
    size: "s",
    mr: 6
  }), /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    size: "m",
    href: supportUrl
  }, "\u041F\u043E\u043C\u043E\u0449\u044C")), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    height: 46,
    alignItems: "center",
    p: "0 18px 0 14px"
  }, /*#__PURE__*/React.createElement(PinBubbleDefaultMapIcon, {
    size: "s",
    mr: 6
  }), /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    size: "m",
    href: officesUrl
  }, "\u041E\u0442\u0434\u0435\u043B\u0435\u043D\u0438\u044F"))), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    flexDirection: "column",
    py: 7,
    borderBottom: "1px solid neutralsBlack.hex10"
  }, menu === null || menu === void 0 ? void 0 : menu.map(function (_ref10, index) {
    var title = _ref10.title,
        items = _ref10.items,
        link = _ref10.link,
        openInNewTab = _ref10.openInNewTab;
    var isLink = !(items !== null && items !== void 0 && items.length);
    return /*#__PURE__*/React.createElement(MobileMenuItem, {
      key: title,
      inNewTab: openInNewTab,
      isActive: !isSsr && isActiveUrl(link),
      underline: "none",
      size: "m",
      href: isLink ? link : "#",
      onClick: isLink ? null : menuEnterHandler(index)
    }, title, !isLink && /*#__PURE__*/React.createElement(ChevronRightNavigationIcon, {
      fontSize: 20,
      ml: "auto"
    }));
  })), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    flexDirection: "column",
    pb: 7
  }, /*#__PURE__*/React.createElement(MobileMenuItem, {
    underline: "none",
    size: "m",
    href: aboutUrl
  }, "\u041E \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438"), /*#__PURE__*/React.createElement(MobileMenuItem, {
    underline: "none",
    size: "m",
    href: newsUrl
  }, "\u041F\u0440\u0435\u0441\u0441-\u0446\u0435\u043D\u0442\u0440"), /*#__PURE__*/React.createElement(MobileMenuItem, {
    underline: "none",
    size: "m",
    href: vacancyUrl
  }, "\u0412\u0430\u043A\u0430\u043D\u0441\u0438\u0438")), /*#__PURE__*/React.createElement(Box, {
    flexbox: true
  }, /*#__PURE__*/React.createElement(BannerPlace, {
    id: "menu-burger"
  })), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    mt: "auto",
    pt: 22,
    height: 92,
    flexShrink: 0,
    borderTop: "1px solid neutralsBlack.hex10",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    pr: 20
  }, /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    target: "_blank",
    rel: "noreferrer",
    size: "m",
    href: "http://vk.com/russianpost"
  }, /*#__PURE__*/React.createElement(VkLogoIcon, {
    fontSize: 22
  }))), /*#__PURE__*/React.createElement(Box, {
    pr: 20
  }, /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    target: "_blank",
    rel: "noreferrer",
    size: "m",
    href: "https://ok.ru/ruspostofficial"
  }, /*#__PURE__*/React.createElement(OkLogoIcon, {
    fontSize: 22
  }))), /*#__PURE__*/React.createElement(Box, {
    pr: 20
  }, /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    target: "_blank",
    rel: "noreferrer",
    size: "m",
    href: "https://t.me/+bXSxMVtXUN5jMjU6"
  }, /*#__PURE__*/React.createElement(TelegramLogoIcon, {
    fontSize: 22
  }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    target: "_blank",
    rel: "noreferrer",
    size: "m",
    href: "https://alice.ya.ru/s/915b48f1-f21d-4982-a4b8-3c2dfd78ff54"
  }, /*#__PURE__*/React.createElement(AlisaLogoIcon, {
    fontSize: 22
  }))))), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    flexDirection: "column",
    flex: "1 0",
    width: screenWidth
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    alignItems: "center",
    justifyContent: "center",
    width: 28,
    mr: -36,
    ml: 8,
    onClick: backHandler("1")
  }, /*#__PURE__*/React.createElement(ChevronLeftNavigationIcon, {
    fontSize: 18
  })), /*#__PURE__*/React.createElement(MobileMenuItem, {
    underline: "none",
    size: "m",
    href: "#",
    fontWeight: "bold",
    onClick: backHandler("1")
  }, backCategoryName[0]), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    ml: "auto",
    pr: 20,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(CloseActionIcon, {
    mt: 2,
    fontSize: "20px",
    onClick: onClose
  }))), currentSubmenu[0].map(function (_ref11) {
    var title = _ref11.title,
        link = _ref11.link,
        _ref11$items = _ref11.items,
        items = _ref11$items === void 0 ? [] : _ref11$items;
    return /*#__PURE__*/React.createElement(MobileMenuItem, {
      underline: "none",
      isActive: isActiveUrl(link),
      size: "m",
      href: link,
      inNewTab: isExternalHost(link),
      onClick: items.length > 0 ? submenuHandler(items, title) : null,
      key: title
    }, title, items.length > 0 && /*#__PURE__*/React.createElement(ChevronRightNavigationIcon, {
      fontSize: 20,
      ml: "auto"
    }));
  })), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    flexDirection: "column",
    flex: "1 0",
    width: screenWidth
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    alignItems: "center",
    justifyContent: "center",
    width: 28,
    mr: -36,
    ml: 8,
    onClick: backHandler("2")
  }, /*#__PURE__*/React.createElement(ChevronLeftNavigationIcon, {
    fontSize: 18
  })), /*#__PURE__*/React.createElement(MobileMenuItem, {
    underline: "none",
    size: "m",
    href: "#",
    fontWeight: "bold",
    onClick: backHandler("2")
  }, backCategoryName[1]), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    ml: "auto",
    pr: 20,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(CloseActionIcon, {
    mt: 2,
    fontSize: "20px",
    onClick: onClose
  }))), currentSubmenu[1].map(function (_ref12) {
    var title = _ref12.title,
        link = _ref12.link,
        _ref12$items = _ref12.items,
        items = _ref12$items === void 0 ? [] : _ref12$items;
    return /*#__PURE__*/React.createElement(MobileMenuItem, {
      underline: "none",
      isActive: isActiveUrl(link),
      size: "m",
      href: link,
      inNewTab: isExternalHost(link),
      onClick: items.length > 0 ? submenuHandler(items, title) : null,
      key: title
    }, title, items.length > 0 && /*#__PURE__*/React.createElement(ChevronRightNavigationIcon, {
      fontSize: 20,
      ml: "auto"
    }));
  })));
};

export default /*#__PURE__*/memo(MobileMenu);